import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Compiler, Component, ComponentRef, Injector, NgModuleFactory, NgModuleRef, OnDestroy, OnInit, QueryList,  Renderer2,  ViewChild,  ViewChildren, ViewContainerRef } from '@angular/core';
import { DiscoveryService } from 'app/discovery/discovery.service';
import { Subscription } from 'rxjs';
import { concatMap, delay, map, tap } from 'rxjs/operators';
import { DynamicComponentLoader } from '../../_service/dynamicComponentLoader.service';

@Component({
  selector: 'app-discovery-in-home',
  templateUrl: './discovery-in-home.component.html',
  styleUrls: ['./discovery-in-home.component.scss'],
  providers: [
  ]
})
export class DiscoveryInHomeComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  private activityComponent:ComponentRef<any> = null;
  hot = [];
  hotshadow = [];///生成一个静态的列表
  hotLength = 16;
  isHotLoading = false;
  shadowOpen = false;
  openType = '';
  detailData;
  constructor(
    private _discoveryService: DiscoveryService,
    private _dynamic:DynamicComponentLoader
  //  private _cd:ChangeDetectorRef,
  ) { }

  // ngAfterViewInit(): void {
  // }

  ngOnDestroy(): void {
    this.createComponents.forEach(p=>p.destroy());
    this.activityComponent?.destroy();
  }

  @ViewChildren("metaList", { read: ViewContainerRef }) metalist:QueryList<ViewContainerRef>;
  @ViewChild("activityBox",{ read: ViewContainerRef, static:false }) activityBox:ViewContainerRef;


  loaded = false;
  ngOnInit(): void {
    for(let i =0;i<this.hotLength;++i)
    {
      this.hotshadow.push(i);
    }
    this.getDiscoveryList();
  }

  getDiscoveryList() {
    if (this.isHotLoading) {
      return;
    }
    var dateObj = Date.now();
    dateObj += 300;
    let date =  new Date(dateObj);
    this.isHotLoading = true;
    this._discoveryService.getHotAlbums(this.hotLength, false)
    .pipe(
      tap(res=>{
        this.hot = res;
      })
    )
    .pipe(
      delay(10),
      concatMap(any=> this.loadMetaList(this.metalist))
    ).pipe(delay(date))
    .subscribe(p=>{
      this.isHotLoading = false;
     // this._cd.detectChanges();
    })

  

  }


  
  private createComponents:Array<ComponentRef<any>> = []
  async loadMetaList(vcrs:QueryList<ViewContainerRef>) {
    //console.log("module loaded",this.loaded)

    if(!this.loaded)
    {
      let module = await this._dynamic.loadModule(import('../../discovery/discovery.module')
      .then(m => m.DiscoveryModule));
      const { DiscoveryMetaComponent } = await import('../../discovery/discovery-meta/discovery-meta.component');
      let component = module.componentFactoryResolver.resolveComponentFactory(DiscoveryMetaComponent);
      let index = 0;
      vcrs.forEach(view=>{
        let created = view.createComponent(component);
        created.instance.custom = true;
        created.instance.item = this.hot[index];
        created.instance.onDeatilOpen.subscribe(this.detailOpenHandler.bind(this))
        this.createComponents.push(created);
        ++index;
      })
      this.loaded = true;
    }
    else
    {
      let index = 0;
      this.createComponents.forEach(item=>{
        if (this.hot[index] === undefined) {
          return;
        }
        item.instance.changeItem(this.hot[index]);///只能在内部调用detectChanges
        ++index;
      })
    }

   // return vcr.createEmbeddedView(component)
  }
  private activeLoaded = false;

  async loadActivity(vcr:ViewContainerRef)
  {
    if(!this.activeLoaded)
    {
      let module = await this._dynamic.loadModule(import('../user-activity/user-activity.module')
      .then(m => m.UserActivityModule));
      const { ActivityDetailComponent } = await import('../user-activity/activity-detail/activity-detail.component');
      let component = module.componentFactoryResolver.resolveComponentFactory(ActivityDetailComponent);
      let created = vcr.createComponent(component);
      created.instance.detailData = this.detailData;
      created.instance.closeDetail.subscribe(this.closeHandler.bind(this));
      (created.location.nativeElement as HTMLElement).style.height = "inherit";
      this.activityComponent = created;
      this.activeLoaded = true;
    }
    else
    {
      this.activityComponent.instance.detailData = this.detailData;
      this.activityComponent.instance.getActivityDetail();
    }


  }

  changeHots() {
    this.getDiscoveryList();
  }

  detailOpenHandler(e) {

    if (e.infoType === 3 || e.infoType === 1 || e.infoType === 0) {
      this.detailData = e;
      this.shadowOpen = true;
      this.openType = 'detail';
    }
    this.loadActivity(this.activityBox).then(()=>{
        console.log(this.detailData)
    });
  }

  closeHandler() {
    console.log("close click")
    this.close();
  }

  close() {
    this.shadowOpen = false;
    this.openType = '';
    this.activityComponent.instance.showPlayer = false;
  }

}
